import React, { useState, useRef, useEffect } from 'react';
import {
  CommentReplyButtonContainer,
  DropdownMenu,
  DropdownItem
} from './styles';

export function CommentReplyButton({ onClick, onReplyComment, comment }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleReply = (replyToAll = false) => {
    onReplyComment({ ...comment, ...(replyToAll ? { replyToAll } : {}) });
    onClick();
    setIsOpen(false);
  };

  return (
    <div
      ref={dropdownRef}
      style={{ position: 'relative', marginRight: '0.25rem' }}
    >
      <CommentReplyButtonContainer
        color="primary"
        size="sm"
        onClick={() => setIsOpen(!isOpen)}
      >
        <i className="fas fa-reply" style={{ marginRight: '5px' }}></i>
        Responder
        <i className="fas fa-caret-down" style={{ marginLeft: '5px' }}></i>
      </CommentReplyButtonContainer>

      {isOpen && (
        <DropdownMenu>
          <DropdownItem onClick={() => handleReply(false)}>
            <i className="fas fa-reply" style={{ marginRight: '5px' }}></i>
            Responder
          </DropdownItem>
          <DropdownItem onClick={() => handleReply(true)}>
            <i className="fas fa-reply-all" style={{ marginRight: '5px' }}></i>
            Responder a todos
          </DropdownItem>
        </DropdownMenu>
      )}
    </div>
  );
}
